function trackAds() {
    const isMobile = (/(Mobile|Opera Mobi|Opera Mini|Android|Phone OS|iPad|iPhone)/.test(navigator.userAgent)),
        ivwElement = document.getElementById('ivw-tag');
    let iam_data = {};

    // @ts-ignore
    if (typeof ivwElement === 'undefined' || typeof iom === 'undefined') {
        return;
    }

    if (isMobile) {
        iam_data = {
            "st": ivwElement.dataset.sitekeymobile,
            "cp": ivwElement.dataset.ivwcode,
            "sv": ivwElement.dataset.isRoot === '1' ? ivwElement.dataset.svkeyhomepage : ivwElement.dataset.svkeymobile,
            "sc": "yes"
        };
        // @ts-ignore
        iom.c(iam_data, 1);
    } else {
        iam_data = {
            "st": ivwElement.dataset.sitekey,
            "cp": ivwElement.dataset.ivwcode,
            "sv": ivwElement.dataset.isRoot === '1' ? ivwElement.dataset.svkeyhomepage : ivwElement.dataset.svkey,
            "sc": "yes"
        };
        // @ts-ignore
        iom.c(iam_data, 1);
    }
}

document.addEventListener("DOMContentLoaded", function () {
    trackAds();
});